import {
  Settings,
  Rocket,
  Monitor,
  Code2,
  CheckCircle,
  Lightbulb,
  BookOpen,
} from 'lucide-react';
import { useProjectStore, type ActiveTab } from '../../store/projectStore';

interface NavItem {
  id: ActiveTab;
  label: string;
  icon: typeof import('lucide-react').Settings;
}

const navItems: NavItem[] = [
  { id: 'b2b-start', label: '快速建站', icon: Rocket },
  { id: 'b2b-preview', label: '預覽確認', icon: Monitor },
  { id: 'b2b-strategy', label: '策略報告', icon: Lightbulb },
  { id: 'b2b-stream', label: 'AI 生成', icon: Code2 },
  { id: 'b2b-deploy', label: '部署上線', icon: CheckCircle },
  { id: 'b2b-gallery', label: '案例庫', icon: BookOpen },
  { id: 'settings', label: '設置', icon: Settings },
];

export function Sidebar() {
  const activeTab = useProjectStore((state) => state.activeTab);
  const setActiveTab = useProjectStore((state) => state.setActiveTab);

  return (
    <aside className="w-full md:w-56 bg-white dark:bg-slate-900 border-r border-slate-200 dark:border-slate-700 flex flex-col shrink-0">
      <nav className="flex-1 p-3">
        <ul className="flex md:flex-col gap-1 overflow-x-auto md:overflow-visible">
          {navItems.map((item) => {
            const Icon = item.icon;
            const active = activeTab === item.id;
            return (
              <li key={item.id}>
                <button
                  type="button"
                  onClick={() => setActiveTab(item.id)}
                  className={`w-full flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors ${
                    active
                      ? 'bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400'
                      : 'text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800'
                  }`}
                >
                  <Icon size={18} />
                  {item.label}
                </button>
              </li>
            );
          })}
        </ul>
      </nav>
    </aside>
  );
}
